var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspiration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.625,
    height: 47.436,
    viewBox: "0 0 47.625 47.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_100",
    "data-name": "Grupo 100",
    transform: "translate(-41.337 700.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M395.4.519a23.718,23.718,0,0,0-23.718,23.718V47.955H395.4a23.718,23.718,0,0,0,23.718-23.718V.519Z",
    transform: "translate(-330.34 -701)",
    fill: "#e9987e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M372.211,24.237a23.718,23.718,0,1,1,23.718,23.718,23.718,23.718,0,0,1-23.718-23.718",
    transform: "translate(-330.685 -701)",
    fill: "#ae88bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M417.185,53.666a7.619,7.619,0,1,1,7.619,7.619,7.619,7.619,0,0,1-7.619-7.619",
    transform: "translate(-359.749 -730.422)",
    fill: "#c3dad4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspiration);
export default __webpack_public_path__ + "static/media/inspiration.bf657327de6bf57d0a1e5b0a2a06e934.svg";
export { ForwardRef as ReactComponent };